let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h8mce")).then(() => parcelRequire('2y2GM'));